import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { XCircleIcon } from "@heroicons/react/24/outline";
import { addToCart, removeFromCart } from "store/features/cartSlice";
import CustomSelect from "./CustomSelect";

const CartModal = ({ item, onClose }) => {
  // const dispatch = useDispatch();
  // const [count, setCount] = useState(1);
  // const totalPrice = count * item.price;

  // const [selectedOption, setSelectedOption] = useState(
  //   item?.subdesc?.[0] || null,
  // );

  // const cart = useSelector((state) => state.cart.cart);

  // const isOptionInCart = cart.some(
  //   (cartItem) =>
  //     cartItem._id === item._id && cartItem.selectedOption === selectedOption,
  // );

  const dispatch = useDispatch();
  const cart = useSelector((state) => state.cart.cart);

  const existingCartItem = cart.find((cartItem) => cartItem._id === item._id);

  const [count, setCount] = useState(existingCartItem?.count || 1);
  const [error, setError] = useState("");

  const [selectedOption, setSelectedOption] = useState(
    existingCartItem?.selectedOption || null,
  );

  const totalPrice = count * item.price;

  const isOptionInCart = cart.some(
    (cartItem) =>
      cartItem._id === item._id && cartItem.selectedOption === selectedOption,
  );

  return (
    <div
      className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-[50]"
      onClick={onClose}
    >
      <div
        className="relative p-4 bg-darkbg rounded-xl shadow-md max-w-lg m-1 z-[60] border border-border max-w-[380px] lg:max-w-[500px]"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Close Button */}
        <button className="absolute top-3 right-4 text-xl" onClick={onClose}>
          <XCircleIcon className="max-w-[24px] w-full text-navy" />
        </button>

        {/* Modal Content */}
        <img
          src={item.image || "/saigonstar/saigonstar_sqr.webp"}
          className="
  max-w-[220px] lg:max-w-[300px]
  rounded-lg
  border-0 border-neonYellow
  transition-transform duration-300 ease-out
  hover:scale-105
"
        />
        <p className="text-[18px] font-semibold text-navy mt-3">{item.title}</p>
        <p className="text-sm sm:text-sm text-text min-w-[330px] lg:min-w-[400px]">
          {item.desc}
        </p>
        {item.subdesc && item.subdesc.length > 0 && (
          <div className="mt-4 space-y-2 ">
            <p className="text-sm font-semibold text-navy tracking-wide">
              Choose Option (*)
            </p>
            {error && (
              <p className="text-red-500 text-xs mt-2 font-semibold">{error}</p>
            )}
            {/* <div className="border border-dotted border-border p-3 bg-navy rounded space-y-3">
              {item.subdesc.map((option, index) => (
                <label
                  key={index}
                  className="flex items-center gap-3  text-sm text-yellowstar"
                >
                  <input
                    type="radio"
                    name={`subdesc-${item._id}`}
                    value={option}
                    checked={selectedOption === option}
                    onChange={() => {
                      setSelectedOption(option);
                      setError("");
                    }}
                    className="text-yellowstar"
                  />
                  {option}
                </label>
              ))}
            </div> */}
            <CustomSelect
              item={item}
              selectedOption={selectedOption}
              setSelectedOption={setSelectedOption}
              setError={setError}
            />
          </div>
        )}

        {/* Quantity Section */}
        <div className="flex items-center justify-between rounded px-0 py-1 my-5">
          <legend className="text-sm text-text font-semibold">Quantity</legend>
          <div className="flex gap-1 items-center text-sm">
            <button
              className="px-3 py-1 hover:bg-gray-100 border border-navy rounded"
              onClick={() => setCount(Math.max(count - 1, 1))}
            >
              -
            </button>
            <p className="px-4 py-1 font-semibold">{count}</p>

            <button
              className="px-3 py-1 hover:bg-gray-100 border border-navy rounded"
              onClick={() => setCount(count + 1)}
            >
              +
            </button>
          </div>
        </div>

        {/* Total Price + Add */}
        <div className="flex justify-between items-center mt-2 px-0 py-1 rounded mt-5  ">
          <legend className="text-sm text-text font-semibold">Total</legend>
          <p className="ml-1 text-navy text-sm">${totalPrice.toFixed(2)}</p>
        </div>
        <div className="flex justify-end items-center gap-x-3 items-center mt-3 p-3 mt-5  border-t border-navy">
          {" "}
          <button
            className="px-6 py-3 bg-navy rounded-lg font-bold tracking-wide text-neonYellow text-sm uppercase animate-neonFlicker hover:bg-gray-600"
            onClick={() => {
              const requiresOption = item.subdesc && item.subdesc.length > 0;

              if (requiresOption && !selectedOption) {
                setError("Please select an option.");
                return;
              }

              setError("");
              dispatch(
                addToCart({
                  item: {
                    ...item,
                    count,
                    selectedOption, // ✅ SAVE IT
                  },
                }),
              );
              onClose(); // close modal after adding
            }}
          >
            Add +
          </button>
          <button
            disabled={!isOptionInCart}
            className={`text-xs px-6 py-3 rounded uppercase tracking-wide underline transition 
    ${
      isOptionInCart
        ? "hover:text-red-500 text-yellowstar"
        : "text-gray-400 cursor-not-allowed"
    }
  `}
            onClick={() => {
              if (!isOptionInCart) return;

              dispatch(
                removeFromCart({
                  _id: item._id,
                  selectedOption,
                }),
              );
              onClose();
            }}
          >
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default CartModal;
